import { type SsoFailureDto, ssoFailureDtoSchema } from "../schemas";

const decodeBase64UrlUtf8 = (encoded: string): string => {
	const base64 = encoded.replace(/-/g, "+").replace(/_/g, "/");
	const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");
	const bytes = Uint8Array.from(atob(padded), (character) => character.charCodeAt(0));

	return new TextDecoder("utf-8", { fatal: true }).decode(bytes);
};

export const decodeSsoFailure = (encoded: string | null): SsoFailureDto => {
	try {
		return ssoFailureDtoSchema.parse(JSON.parse(decodeBase64UrlUtf8(encoded ?? "")));
	} catch {
		return ssoFailureDtoSchema.parse(undefined);
	}
};
